import React, { ReactElement } from "react";

import { camelCase } from "./stringUtilHelper";
import { AnyObject } from "../interfaces/anyObject";
import Templates from "../templates/simpleTemplates";

// Todo: TS Replace with generic kontent interface
interface ContentItem {
  internal: {
    type: string;
  };
  elements?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

const mapContentItem = (item: ContentItem): ReactElement | string => {
  let output: ReactElement | string = "";

  if (item?.internal?.type) {
    const type = camelCase(item.internal.type);

    // @ts-expect-error Implicit any
    const TagName = Templates[`${type.charAt(0).toUpperCase()}${type.slice(1)}`];
    let props: AnyObject;

    if (!TagName || !item.elements) {
      return <div className="alert alert-warning">## missing element ##</div>;
    }

    switch (item.internal.type) {
      case "kontent_item_image_grid":
        props = {
          enableCaption: true,
        };
        break;
      case "kontent_item_image":
        props = {
          enableCaption: true,
          enableComponentStyle: true,
        };
        break;
      default:
        props = {};
    }

    try {
      output = <TagName data={item} {...props} />;
    } catch {
      output = "Error";
    }
  }

  return output;
};

export default mapContentItem;
